"use client";

/**
 * The persistent "you are talking to an AI" badge, web half of CMP-06.
 *
 * WHY THIS EXISTS ON WEB AT ALL. CMP-06 is worded without a client: "a
 * persistent, visible AI indicator in the conversation header on every tutoring
 * screen". The badge shipped on iOS first because App Review reads 5.1.2(i),
 * and the copy was put in THIS repository's catalogs because iOS reads them -
 * so `common.aiIndicator` has been sitting in `en`, `es` and `pt-BR` since,
 * referenced by no web component. The web app is live and its scenario mode
 * casts the model as a person; the requirement was half done and looked whole.
 *
 * IT IS THE VISIBLE HALF OF A PAIR. The other half is `AI_DISCLOSURE_RULE`,
 * which makes the model answer truthfully when a learner sincerely asks. This
 * is what tells a learner who never thinks to ask.
 *
 * STYLED FOR A COLOURED FILL, which is why there is no theme handling here.
 * Both placements (the scenario header and the tutor widget header) sit on a
 * fixed coloured header, the same condition the `theme-exempt` comments in
 * those two files already record.
 *
 * THE ACCESSIBLE LABEL IS THE SENTENCE, not the two letters. "AI" read aloud is
 * an initialism a screen-reader user has to guess at, which is not a disclosure.
 */

import { useTranslations } from "@i18n/provider";

export function AiIndicator() {
  const { t } = useTranslations();

  return (
    <span
      data-testid="ai-disclosure"
      aria-label={t("common.aiIndicatorHint")}
      // theme-exempt: on the conversation and tutor header fills.
      className="flex-shrink-0 rounded-full border border-white/40 px-1.5 py-0.5 font-display text-[10px] font-bold leading-none tracking-wide text-white/90"
    >
      {t("common.aiIndicator")}
    </span>
  );
}
